import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  handleCallback,
  consumePendingNumber,
  getReturnPath,
  clearReturnPath,
  isPopupLogin,
} from '../../lib/ringcentral/auth';

const RcCallback = () => {
  const navigate = useNavigate();
  const [popupMessage, setPopupMessage] = useState(null);

  useEffect(() => {
    const run = async () => {
      // Popup sign-in (RC status chip / send pre-check): the opener is
      // watching localStorage for the tokens — this window just finishes
      // the exchange and closes itself. No navigation, opener keeps state.
      if (isPopupLogin()) {
        try {
          await handleCallback();
          setPopupMessage('Signed in. You can close this window.');
        } catch (e) {
          setPopupMessage(e.message || 'RingCentral authorization failed.');
        }
        window.close();
        return;
      }

      const returnPath = getReturnPath();
      try {
        await handleCallback();
        consumePendingNumber();
        navigate(returnPath);
      } catch (e) {
        toast.error(e.message || 'RingCentral authorization failed');
        navigate(returnPath);
      } finally {
        clearReturnPath();
      }
    };
    run();
  }, [navigate]);

  return (
    <div className="p-4">{popupMessage || 'Authorizing RingCentral...'}</div>
  );
};

export default RcCallback;
